import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { TaskItemStatus } from '@r1-development/resolution-mechanicalturk-api-client';
import { TaskTypes } from 'src/app/shared/models/tasks.model';
import { SidebarTaskGroupUi, SidebarTaskUi } from '../../model/sidebar.model';
import { SidebarGroupTasksComponent } from '../sidebar-group-tasks/sidebar-group-tasks.component';

@Component({
  selector: 'ri-resolution-ui-sidebar-flat-tasks-list',
  imports: [SidebarGroupTasksComponent],
  templateUrl: './sidebar-flat-tasks-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarFlatTasksListComponent {
  readonly tasks =
    input.required<(SidebarTaskUi & { routerLinkPath: string[] })[]>();

  readonly taskGroups = computed(() => {
    return this.tasks().map((task) => {
      const taskGrouper: SidebarTaskGroupUi = {
        id: 'group-' + task.id,
        taskType: task.taskType,
        completedById: task.completedById,
        tasks: [task],
        title: task.title,
        taskStatus: task.taskStatus,
        globalEligible: task.globalEligible,
      };
      return taskGrouper;
    });
  });

  readonly taskTypes = TaskTypes;
  readonly taskItemStatus = TaskItemStatus;
}
